import { find, get, set } from 'lodash';
import { Threshold, SeverityThreshold } from './threshold';

export class Thresholds {
  thresholds;
  constructor(thresholdsData: Array<Threshold>) {
    this.setThresholds(thresholdsData);
  }

  setThresholds(response: Array<Threshold> = []) {
    const thresholds = {
      eue: {},
      mos: {}
    };

    response.forEach(th => {
      if (this.isMOSkpiFor(th)) {
        th.severityThresholds.forEach(sTh => {
          this.setWorstGroupedTh(sTh, thresholds.mos, th.dimensions);
        });
      }

      if (this.isEUEkpiFor(th, th.dimensions)) {
        th.severityThresholds.forEach(sTh => {
          if (['siteresourceid', 'appresourceid'].indexOf(th.dimensions) > -1) {
            this.setWorstGroupedTh(sTh, thresholds.eue, th.dimensions);
          }
        });
      }
    });
    this.thresholds = thresholds;
  }

  setWorstGroupedTh(sTh: SeverityThreshold, thGroup, dimensions) {
    const staticValues = sTh.staticValues || 'default';
    sTh.severityThresholdPairs.forEach(sThP => {
      const path = `${dimensions}.${staticValues}.${sThP.severity}`;
      if (get(thGroup, path, 0) < sThP.threshold || sThP.threshold === 0) {
        set(thGroup, path, sThP.threshold);
      }
    });
  }

  isEUEkpiFor(th: Threshold, dimensions) {
    return (
      th.dimensions === dimensions &&
      [
        'eueserverscore',
        'euenetworkscore',
        'eueapplicationscore',
        'eueclientscore'
      ].indexOf(th.kpiname) > -1
    );
  }

  isMOSkpiFor(th: Threshold) {
    return ['mosaudioaverage'].indexOf(th.kpiname) > -1;
  }

  getStaticThreshold(kpi, dimensionObj) {
    const key = [
      'site1resourceid',
      'site2resourceid',
      'site',
      'site2'
    ].includes(dimensionObj.key)
      ? 'siteresourceid'
      : dimensionObj.key;
    const path = `${kpi}.${key}`;
    let th = get(this.thresholds, `${path}.${dimensionObj.value}`);
    if (!th) {
      th = get(
        this.thresholds,
        `${path}.default`,
        kpi === 'eue'
          ? { Critical: 5,
Warning: 8 }
          : { Critical: 2,
Warning: 3 }
      );
    }

    return [
      {
        type: 'critical',
        color: '#D50032',
        value: th.Critical,
        validationType: 'LESS'
      },
      {
        type: 'warning',
        color: '#f57902',
        value: th.Warning,
        validationType: 'LESS'
      },
      {
        type: 'good',
        color: '#3371B2',
        value: th.Warning,
        validationType: 'MORE_EQ'
      }
    ];
  }

  validateStaticThresholdStatus(kpi: string, value: number, dimensionObj) {
    const threshold = this.getStaticThreshold(kpi, dimensionObj);
    const status = find(threshold, item => {
      return this.getStatusFromThresholdObj(value, item);
    });

    if (status) {
      return status.type;
    }

    return null;
  }

  getStatusFromThresholdObj(value: number, threshold: any) {
    const validation = threshold.validationType;
    switch (validation) {
      case 'EQ': {
        return value === threshold.value;
      }
      case 'LESS': {
        return value < threshold.value;
      }
      case 'MORE': {
        return value > threshold.value;
      }
      case 'LESS_EQ': {
        return value <= threshold.value;
      }
      case 'MORE_EQ': {
        return value >= threshold.value;
      }
    }

    return false;
  }
}
